import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { additional_routes } from './app-routing.module.dev';
import { environment } from 'src/environments/environment';
import { MemberboxRoutingRoutes } from './memberbox-routing.routes';
import { CashRegisterRoutingRoutes } from './cashregister-routing.routes';
import { CashRegisterLoginGuard } from './guards/cashregister-login.guard';

const routes: Routes = [
  {
    path:         'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule),
    canActivate:  [CashRegisterLoginGuard]
  },
  {
    path:          'logout',
    loadComponent: () => import('./standalone/logout/logout.page').then(p => p.LogoutPage),
  },
  ...additional_routes,
  ...(!environment.isCashRegister ? MemberboxRoutingRoutes : CashRegisterRoutingRoutes),
  { // this have to be the last route entry!
    path:          '**',
    // FIXME @Chris this component changes the default button/dropdown style (blue)
    // and this should be an direct app.component and not lazy loaded anyway
    loadComponent: () => import('./standalone/404/not-found.page').then(p => p.NotFoundPage),
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy:        PreloadAllModules,
      enableTracing:             false,
      anchorScrolling:           'enabled',
      scrollPositionRestoration: "enabled",
      bindToComponentInputs:     true,
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
